import React, { useState } from 'react'
import {
  Table,
  useTable,
  DeleteButton,
  Grid,
  Typography,
  CreateButton,
  Space,
  useModalForm,
  Button,
  Icons,
  Input,
  Form,
  Modal,
} from '@pankod/refine-antd'
import { IParentChildReference } from 'interfaces'
import RichTextRender from 'components/questions/rich_text_render'
import SunTextEditor from 'components/questions/sun_text_editor'

interface IRecord {
  record: any
  userId: string
  userRole: string
}

const MemoizedRichTextRender = React.memo(RichTextRender)
const ReferenceDataTable: React.FC<IRecord> = ({ record, userId, userRole }) => {
  console.log(record, 'Record')
  const [referenceData, setReferenceData] = useState('')
  const [modalMode, setModalMode] = useState<'view' | 'edit'>('edit')
  const breakpoint = Grid.useBreakpoint()
  const isMobile = !breakpoint.md
  const { tableQueryResult: referencetTextQueryResult, tableProps } = useTable<IParentChildReference>({
    resource: 'parent_child_question_reference_data',
    permanentFilter: record?.id
      ? [
          {
            field: 'work_request_id',
            operator: 'eq',
            value: record?.id,
          },
        ]
      : [],
      metaData: {
        fields: [
          'id',
          'reference_data',
          {questions:['id']},
        ],
      },
      
    initialSorter: [
      {
        field: 'updated_at',
        order: 'desc',
      },
    ],
    initialPageSize: 1,
    hasPagination: true,
  })
  // creating reference data
  const { modalProps, formProps, show } = useModalForm<IParentChildReference>({
    action: 'create',
    resource: 'parent_child_question_reference_data',
    redirect: false,
    defaultVisible: false,
    onMutationSuccess: () => {
      setReferenceData('')
      formProps?.form?.resetFields()
    },
  })
  //editing reference data
  const {
    modalProps: editModalProps,
    formProps: editFormProps,
    show: showEdit,
  } = useModalForm<IParentChildReference>({
    action: 'edit',
    resource: 'parent_child_question_reference_data',
    redirect: false,
    defaultVisible: false,
    metaData: {
      fields: ['id', 'reference_data', 'work_request_id', 'creator_id'],
    },
    onMutationSuccess: () => {
      setReferenceData('')
      editFormProps?.form?.resetFields()
    },
  })

  return (
    <div style={{ width: isMobile ? '100%' : '50%', marginBottom: '1rem', marginTop: '1rem' }}>
      <Space
        align="center"
        style={{
          marginBottom: '0.5rem',
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        }}
      >
        <b>Reference Texts:</b>
        {userRole === 'qcreator' && (
          <Button
            type="primary"
            size="small"
            icon={<Icons.PlusOutlined />}
            onClick={() => show()}
            disabled={!!(referencetTextQueryResult?.data?.total && referencetTextQueryResult?.data?.total >= record?.count)}
          />
        )}
      </Space>

      <Table<IParentChildReference> {...tableProps} rowKey="id" size="small">
        <Table.Column<IParentChildReference>
          dataIndex="reference_data"
          title="Reference Data"
          width="80%"
          render={(_, record) => (
            <Typography.Text
              style={{
                textAlign: 'left',
                cursor: 'pointer',
                width: '100%',
                display: 'block',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
              title={record?.reference_data}
            >
              <div style={{ width: '100%' }}>
                <MemoizedRichTextRender content={record.reference_data} />
              </div>
            </Typography.Text>
          )}
        />

        <Table.Column<IParentChildReference>
          title="Actions"
          width="20%"
          render={(_, record) => (
            <Space>
              <Button
                size="small"
                icon={<Icons.EyeOutlined />}
                onClick={() => {
                  setReferenceData(record?.reference_data)
                  setModalMode('view')
                  // showView(record.id)
                  showEdit(record.id)
                }}
              />
              {userRole === 'qcreator' && (
                <Button
                  size="small"
                  icon={<Icons.EditOutlined />}
                  onClick={() => {
                    setReferenceData(record?.reference_data)
                    setModalMode('edit')
                    showEdit(record.id)
                  }}
                />
              )}
              {userRole === 'qcreator' && (
                <DeleteButton
                  size="small"
                  recordItemId={record.id}
                  hideText
                  resourceName="parent_child_question_reference_data"
                  confirmTitle="Are you sure you want to delete this reference?"
                  hidden = {record?.questions?.length>0}
                />
              )}
            </Space>
          )}
        />
      </Table>

      {/* Create Modal */}
      <Modal {...modalProps} title="Create Reference Data" destroyOnClose>
        <Form {...formProps} layout="vertical">
          <Form.Item label="Reference Data" name="reference_data" rules={[{ required: true, message: 'Reference is required' }]}>
            <SunTextEditor
              key={record?.id}
              id="reference_data"
              initialValue={referenceData}
              formValueSetterFn={(content: string) => {
                console.log(content, 'Content')
                formProps?.form?.setFieldsValue({ reference_data: content })
                setReferenceData(content)
              }}
            />
          </Form.Item>
          <Form.Item name="work_request_id" initialValue={record?.id} hidden>
            <Input type="hidden" />
          </Form.Item>
          <Form.Item name="creator_id" initialValue={userId} hidden>
            <Input type="hidden" />
          </Form.Item>
        </Form>
      </Modal>
      {/* Edit/View Modal */}
      <Modal
        {...editModalProps}
        title={modalMode === 'view' ? 'View Reference Data' : 'Edit Reference Data'}
        destroyOnClose
        footer={modalMode === 'view' ? null : undefined}
      >
        <Form {...editFormProps} layout="vertical">
          <Form.Item label="Reference Data" name="reference_data" rules={[{ required: true }]}>
            <SunTextEditor
              key={editFormProps.form?.getFieldValue('id')}
              id="reference_data"
              initialValue={referenceData}
              formValueSetterFn={(content: string) => {
                editFormProps?.form?.setFieldsValue({ reference_data: content })
                setReferenceData(content)
              }}
              hideToolBar={modalMode === 'view' ? true : false}
            />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

export default ReferenceDataTable
